import React, { useState, useEffect } from "react";
import { QRCodeSVG as QRCode } from "qrcode.react";

export default function ShareModal({ gameId, onClose }) {
  const [isAnimating, setIsAnimating] = useState(false);
  const [isCopied, setIsCopied] = useState(false);
  const shareUrl = `${window.location.origin}${window.location.pathname}?room=${gameId}`;

  useEffect(() => {
    const timer = setTimeout(() => setIsAnimating(true), 10);
    return () => clearTimeout(timer);
  }, []);

  const handleClose = () => {
    setIsAnimating(false);
    setTimeout(onClose, 300);
  };

  const handleCopyLink = () => {
    navigator.clipboard.writeText(shareUrl);
    setIsCopied(true);
    setTimeout(() => setIsCopied(false), 2000);
  };

  return (
    <div
      className={`fixed inset-0 flex items-center justify-center z-50 p-4 transition-colors duration-300 ${
        isAnimating ? "bg-black/70" : "bg-black/0"
      }`}
      onClick={handleClose}
    >
      <div
        className={`bg-[#f3e9d2] text-[#5a4a3a] p-6 rounded-lg shadow-2xl border-4 border-gray-700 w-full max-w-sm flex flex-col items-center gap-5 transition-all duration-300 ease-out ${
          isAnimating ? "scale-100 opacity-100" : "scale-75 opacity-0"
        }`}
        onClick={(e) => e.stopPropagation()}
      >
        <p className="text-2xl font-bold font-serif tracking-wide text-center">เชิญเพื่อนเข้าร่วม</p>
        <div className="bg-white p-4 rounded-xl border-2 border-[#c8bda9] shadow-inner">
          <QRCode value={shareUrl} size={192} fgColor="#5a4a3a" />
        </div>
        <div className="w-full flex flex-col items-center gap-3">
          <p className="text-sm font-medium text-center text-[#6b5846] leading-relaxed px-2">
            ให้เพื่อนสแกน QR Code หรือส่งลิงก์ให้โดยตรง
          </p>
          <div className="w-full flex gap-2 items-center">
            <input
              type="text"
              value={shareUrl}
              readOnly
              className="flex-grow p-3 bg-[#e1d4be] rounded-lg border-2 border-[#c8bda9] text-[#5a4a3a] text-sm font-medium focus:outline-none transition-colors hover:border-[#bdae97]"
            />
            <button
              onClick={handleCopyLink}
              className={`p-3 rounded-lg shadow-md flex items-center justify-center transition-all duration-200 active:scale-95 active:shadow-inner shrink-0 ${
                isCopied
                  ? "bg-green-700 hover:bg-green-800 text-white"
                  : "bg-[#a08d70] hover:bg-[#8d7c62] text-white"
              }`}
              title="คัดลอกลิงก์"
            >
              {isCopied ? (
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                </svg>
              ) : (
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                  <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
                  <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
                </svg>
              )}
            </button>
          </div>
        </div>
        <button
          onClick={handleClose}
          className="w-full bg-[#8b6b4e] hover:bg-[#725a40] text-white font-bold py-3 px-4 rounded-lg shadow-md transition-transform active:scale-95"
        >
          ปิด
        </button>
      </div>
    </div>
  );
}
